// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Chip, styled } from "@3778.care/goban";
import PropTypes from "prop-types";

const statusLabel = {
  booked: "Agendada",
  cancelled: "Cancelada",
  finished: "Finalizada",
  inProgress: "Iniciada",
  noshow: "Ausência",
};

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "status",
})(({ status, theme: { palette } }) => ({
  fontSize: 13,
  fontWeight: "400",
  height: "1.5rem",
  marginLeft: "8px",
  "& .MuiChip-label": {
    padding: 0,
  },
  ...(status === "booked" && {
    backgroundColor: palette.grey[300],
    color: palette.text.primary,
    padding: "0.35rem 0.5rem",
  }),
  ...(status === "cancelled" && {
    backgroundColor: palette.error.light,
    color: palette.text.primary,
    padding: "0.35rem 0.5rem",
  }),
  ...(status === "finished" && {
    backgroundColor: "transparent",
    border: `2px solid ${palette.grey[300]}`,
    color: palette.text.primary,
    padding: "0.25rem 0.5rem",
  }),
  ...(status === "inProgress" && {
    backgroundColor: "transparent",
    border: `1px solid ${palette.secondary.main}`,
    color: palette.secondary.dark,
    padding: "0.25rem 0.5rem",
  }),
  ...(status === "noshow" && {
    backgroundColor: palette.warning.light,
    color: palette.text.primary,
    padding: "0.35rem 0.5rem",
  }),
}));

export const StatusChip = ({ status }) => (
  <StyledChip status={status} label={statusLabel[status]} />
);

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
};
